import axiosHttp from "services/axiosHttp";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";

export const fetchPreferredUnitUpload = createAsyncThunk(
	"fetchPreferredUnitUpload",
	async ({ file, channelId }, { rejectWithValue }) => {
		try {
			const formData = new FormData();
			formData.append("file", file);
			const response = await axiosHttp.post(`channel/${channelId}/unitDetails/preferred-upload`, formData);
			message.success("Preferred units uploaded successfully!");
			return response.data.data;
		} catch (error) {
			return rejectWithValue(error.response?.data?.message || "Something went wrong");
		}
	}
);

const PreferredUnitUploadSlice = createSlice({
	name: "PreferredUnitUploadSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	reducers: {
		resetPreferredUnitUploadSlice: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchPreferredUnitUpload.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});

		builder.addCase(fetchPreferredUnitUpload.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchPreferredUnitUpload.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || "Unknown error occurred";
		});
	},
});

export default PreferredUnitUploadSlice.reducer;
export const { resetPreferredUnitUploadSlice } = PreferredUnitUploadSlice.actions;

